export enum TenantName {
    default = 'Default',
    senior = 'Senior',
    unica = 'Unica',
    caresWell = 'Careswell',
}
